import type { Model } from '@patsnap/tahiti-core';
import type { CurrentStep } from '../enums';

/**
 * 专利信息接口
 */
export interface PatentInfo {
    /** 专利标题 */
    readonly title: string;
    /** 专利摘要 */
    readonly abstract: string;
    /** 专利号 */
    readonly patentNumber: string;
    /** 申请人 */
    readonly applicant: string;
    /** 申请日期 */
    readonly applicationDate: string;
    /** 相似度评分 */
    readonly similarity?: number;
    /** 技术标签 */
    readonly tags?: string[];
    /** 专利ID */
    readonly patentId: string;
    /** 是否已选中（用于自定义检索结果） */
    readonly selected?: boolean;
}

/**
 * 检索轮次
 */
export interface SearchRound {
    /** 检索式 */
    query: string;
    /**
     * 是否人工输入的检索式
     */
    isManual: boolean;
    /** 检索结果数量 */
    patentCount: number;
    /** 各筛选步骤后的专利数量 */
    filteredPatentCounts: Record<CurrentStep, number>;
    /** 检索状态 */
    status: 'pending' | 'running' | 'completed' | 'error';
    /**
     * 轮次中的步骤，使用 CurrentStep 枚举
     * @description Query(-1) 表示查询步骤，FilterStep1(0) 表示筛选步骤1，FilterStep2(1) 表示筛选步骤2，FilterStep3(2) 表示筛选步骤3，Final(3) 表示最终展示步骤
     */
    currentStep: CurrentStep;
    /**
     * 是否当前选中的检索轮次
     */
    isSelected: boolean;
}

/**
 * 专利信息模型
 */
export interface PatentsModel extends Model<PatentInfo[]> {

}

export const PatentsModel = Symbol('PatentsModel');
/**
 * 检索轮次模型
 */
export interface SearchRoundsModel extends Model<SearchRound[]> {

}

export const SearchRoundsModel = Symbol('SearchRoundsModel');
